import { z } from "zod";

export const formSchema = z.object({
    connectionSequenceSteps: z.string(),
});

export type ModifyIntegrationMethodsFormData = z.infer<typeof formSchema>;
